<template>
  <v-tooltip top v-model="showTooltip" content-class="info tooltip-top tooltip"
             max-width="400"
  >
    <template v-slot:activator="{ on }">
      <span v-on="on">
      <v-btn v-if="action" block x-large elevation="0" :color="actionColor" class="invite-button mt-6" @click="$emit('click-button')">
        {{ actionText }}<v-icon
          right
          dark
      >
        {{ actionIcon }}
      </v-icon>
      </v-btn>

        <v-icon v-else-if="currentTooltip === 0" dark :color="iconColor ? iconColor : 'primary'">info</v-icon>
        <span v-else-if="currentTooltip > 0"></span>
        <span v-else></span>
        </span>


    </template>
    <template v-slot:default>
      <v-card flat dark color="info">
        <v-card-title class="flex justify-space-between pr-0">
          <div>{{ title }}</div>
          <v-btn v-if="currentTooltip" icon @click="$emit('end-tips')"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <div class="text-body-1 text-left">{{ content }}</div>
        </v-card-text>
        <v-card-actions v-if="currentTooltip" class="justify-space-between">
          <span>{{ currentTooltip }}/{{ tooltipsLength }}</span>
          <div class="flex-grow-1"></div>
          <FaqTooltip v-if="faqId" :id="faqId" class="mr-6"></FaqTooltip>
          <v-btn
              v-if="currentTooltip < tooltipsLength"
              small
              elevation="0"
              color="success"
              @click="$emit('next-tip')"
          >{{ $t('buttons.Next tip') }}</v-btn>
          <v-btn
              v-else
              small
              elevation="0"
              color="success"
              @click="$emit('end-tips')"
          >{{ $t('buttons.End tour') }}</v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-tooltip>
</template>

<script>

import FaqTooltip from "./FaqTooltip";

export default {
  name: "Tooltip",
  props: ['title', 'content', 'model', 'currentTooltip', 'tooltipsLength', 'show', 'action', 'actionText', 'actionIcon', 'actionColor', 'faqId', 'iconColor'],
  components: {
    FaqTooltip
  },
  data () {
    return {
      showTooltip: false,
    }
  },
  watch: {
    show(val) {
      this.showTooltip = val
    }
  }
}
</script>

<style scoped>
  .tooltip-top::before {
    border-right: solid 8px transparent;
    border-left: solid 8px transparent;
    transform: translateX(-50%);
    position: absolute;
    z-index: -21;
    content: '';
    top: 100%;
    left: 50%;
    height: 0;
    width: 0;
  }
  .tooltip-top.error::before{
    border-top: solid 8px #ff6060;
  }

  .tooltip-top.success::before{
    border-top: solid 8px #1B5E20;
  }
  .tooltip-top.secondary::before{
    border-top: solid 8px #3f3f3f;
  }

  .tooltip-top.primary::before{
    border-top: solid 8px #246fb3;
  }

  .tooltip-top.info::before{
    border-top: solid 8px #1B1464;
  }


  .tooltip-bottom::before{
    border-right: solid 8px transparent;
    border-left: solid 8px transparent;
    transform: translateX(-50%);
    position: absolute;
    z-index: -21;
    content: '';
    bottom: 100%;
    left: 50%;
    height: 0;
    width: 0;
  }

  .tooltip-bottom.error::before{
    border-bottom: solid 8px #ff6060;
  }

  .tooltip-bottom.success::before{
    border-bottom: solid 8px #1B5E20;
  }
  .tooltip-bottom.secondary::before{
    border-bottom: solid 8px #3f3f3f;
  }

  .tooltip-bottom.primary::before{
    border-bottom: solid 8px #246fb3;
  }

  .tooltip-bottom.info::before{
    border-bottom: solid 8px #1B1464;
  }


  .tooltip-right::before{
    content: " ";
    position: absolute;
    top: 50%;
    right: 100%; /* To the left of the tooltip */
    margin-top: -8px;
    border-width: 8px;
    border-style: solid;
    border-top: solid 8px transparent;
    border-bottom: solid 8px transparent;
    border-left: solid 8px transparent;
  }

  .tooltip-right.error::before{
    border-right: solid 8px #ff6060 !important;
  }

  .tooltip-right.success::before{
    border-right: solid 8px #1B5E20 !important;
  }
  .tooltip-right.secondary::before{
    border-right: solid 8px #3f3f3f !important;
  }

  .tooltip-right.primary::before{
    border-right: solid 8px #246fb3 !important;
  }

  .tooltip-right.info::before{
    border-right: solid 8px #1B1464 !important;
  }

  .tooltip-left::before{
    content: " ";
    position: absolute;
    top: 50%;
    left: 100%; /* To the left of the tooltip */
    margin-top: -8px;
    border-width: 8px;
    border-style: solid;
    border-top: solid 8px transparent;
    border-bottom: solid 8px transparent;
    border-right: solid 8px transparent;
  }

  .tooltip-left.error::before{
    border-left: solid 8px #ff6060 !important;
  }

  .tooltip-left.success::before{
    border-left: solid 8px #1B5E20 !important;
  }
  .tooltip-left.secondary::before{
    border-left: solid 8px #3f3f3f !important;
  }

  .tooltip-left.primary::before{
    border-left: solid 8px #246fb3 !important;
  }

  .tooltip-left.info::before{
    border-left: solid 8px #1B1464 !important;
  }

  .v-tooltip__content {
    pointer-events: all !important;
  }

  .v-list-item__title:hover {
    cursor: pointer
  }

  .v-tooltip__content {
    opacity: 1 !important;
  }

  .invite-button.v-btn {
    border-radius: 10px;
    height: 56px !important;
    padding-left: 50px !important;
    padding-right: 50px !important;
    text-transform: none !important;
  }

  .tooltip {
    border-radius: 10px !important;
  }
</style>
